import { useEffect, useState } from 'react';

/** True at phone width (the layout switches at 760px). */
export function usePhone() {
  const q = '(max-width: 760px)';
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => { const mq = window.matchMedia(q); const f = () => setM(mq.matches); mq.addEventListener('change', f); return () => mq.removeEventListener('change', f); }, []);
  return m;
}

/** The time now, ticking every minute (for Now lines and "in 1h 20m"). */
export function useNow(everyMs = 60_000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = window.setInterval(() => setNow(new Date()), everyMs); return () => window.clearInterval(t); }, [everyMs]);
  return now;
}
